const NUMERICAL_REG = /^([1-9]\d*)$/;
const HOUR_REG = /^([1-9]\d*(h|hour|hours|\.))$/;
const MINUTE_REG = /^([1-9]\d*(m|mins|min))$/;
const HOUR_MINUTE_REG = /^([1-9]\d*h)([1-5]?\dm)|([1-9]\d*(hour|hours))([1-5]?\d(mins|min))$/;
const HOUR_ALL_REG = /^([0-9]\d*):([0-5][0-9])|([0-9]\d*).([0-9]|[0-9][0-9])$/;

export function validHour(value) {
  const value_no_space = value ? value.replace(/\s+/g,"") : '';
	return value_no_space.length === 0 || NUMERICAL_REG.test(value_no_space) || HOUR_REG.test(value_no_space) || MINUTE_REG.test(value_no_space) || HOUR_MINUTE_REG.test(value_no_space) || HOUR_ALL_REG.test(value_no_space) || false
}

export function validHourRule(value) {
  const value_no_space = value ? value.replace(/\s+/g,"") : '';
	return value_no_space.length === 0 || NUMERICAL_REG.test(value_no_space) || HOUR_REG.test(value_no_space) || MINUTE_REG.test(value_no_space) || HOUR_MINUTE_REG.test(value_no_space) || HOUR_ALL_REG.test(value_no_space) || 'Invalid format.'
}
